import { CreateStageRequest } from './create-stage-request';

export class UpdateTaskRequest {
   propertyId?: number;
   scheduleId: number = 0;
   stages: CreateStageRequest[] = [];
   description: string = '';
}
